<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 Maquinaria
              | &nbsp
              a.button.is-dark.is-rounded(@click='backPage')
                i.fas.fa-times
        .columns
          .column.is-12.has-text-right
            a.button.is-success(@click="downloadMaquinaria")
              span.icon
                i.fa.fas.fa-download
              | &nbspDescargar
        .columns
          .column.is-12
            TbMaquinaria(:origen="origen" :companias="companias" :articulos="articulosShow" @update="updateData")
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import TbMaquinaria from './shared/TbMaquinaria.vue'
  import { mapState } from 'vuex'
  export default {
    name: 'ContainerMaquinaria',
    components: { Loader, NavBarInventario, TbMaquinaria },
    data() {
      return {
        isLoading: true,
        articulos: [],
        articulosShow: [],
        origen: {},
        almacenes: [],
        companias: [],
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerAlmacenes()
      },

      obtenerAlmacenes () {
        InventarioServices.getAlmacenesConsumibles('c')
        .then( data => {
          this.almacenes = data.map(this.convertirAlmacenes)
          this.obtenerAlmacenOrigen()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },

    convertirAlmacenes (ofi) {
      return {
        ...ofi,
        id: parseInt(ofi.id),
        id_ubicacion: parseInt(ofi.id_ubicacion),
        id_oficina: parseInt(ofi.id_oficina),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
      }
    },
    obtenerAlmacenOrigen() {
      const $origenOfi = this.almacenes.find( ofi => ofi.clave === this.almacenSelect)
      if (!$origenOfi) {
        this.almacenes.map( alm => {
          const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
          if (encontrado) {
            this.origen = alm
          }
        })
      } else {
        this.origen = $origenOfi
      }
      this.obtenerCompanias()
      
    },

      obtenerMaquinaria () {
        InventarioServices.getMaquinaria()
          .then( data => {
            this.articulos = data.map(this.convertirMaquinaria)
            this.articulosShow = this.articulos
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convertirMaquinaria (maq) {
        return {
          ...maq,
          id: parseInt(maq.id),
        }
      },

      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backPage () {
        this.$router.back()
      },

      downloadMaquinaria () {
        this.isLoading = true
        InventarioServices.descargarMaquinaria()
          .then( data => {
            if (data.success) {
              const currentUrl = window.location.hostname
              open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_All.php?nameFile=${data.file}`, '_blank')
              setTimeout(() => {
                InventarioServices.borrarFile_InventarioUser(data.file)
                  .then( resDel => {
                    this.isLoading = false
                  })
              }, 4000)
            } else {
              this.isLoading = false
              this.displayToast('bubble',data.respuesta, 'ban', 'OK')
            }
          })
          .catch((e=> {
            this.isLoading = false
            this.displayToast('bubble',e.message, 'ban', 'OK')
          }))
      },

      obtenerCompanias() {
        console.log('obtenerCompanias')
        InventarioServices.getCompanias()
          .then( data => {
            this.companias = data.map(this.convertirCompanias)
            this.obtenerMaquinaria()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      updateData() {
        console.log('update')
        this.obtenerMaquinaria()
      },

      convertirCompanias(comp) {
        return {
          ...comp,
          id: parseInt(comp.id),
        }
      },

    },

    created () {
      this.iniciarComponente()
    },
    
    computed: {
      ...mapState(['userLogin', 'almacenSelect'])
    }

  }
</script>

<style scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ContainerMaquinaria.vue